<script lang="ts">
  import { Content } from '@smui/card';
  import Dialog from '@smui/dialog';
  import { getAppConfig } from '../../../common/config/app-config';
  import { getStr, globalCurrencyTag } from '../../../common/util';
  import ExtraButton from '../../common/components/ExtraButton.svelte';
  import Icon from '../../common/components/Icon.svelte';
  import { openPdpJoodBenefitInfoPopup, pdpJoodBenefitInfo } from '../store/pdp_store';

  export let open;
  export let primeBenefits;

  const { encodedContextPath } = getAppConfig();

  let VIP = [];
  let SMART = [];
  let BASIC = [];

  $: if (primeBenefits?.primeHighlights) {
    VIP = primeBenefits.primeHighlights.filter(item => item.type === 'VIP' || !item.type);
    SMART = primeBenefits.primeHighlights.filter(item => item.type === 'SMART' || !item.type);
    BASIC = primeBenefits.primeHighlights.filter(item => item.type === 'BASIC' || !item.type);
  }

  $: if (open) {
    setTimeout(() => {
      document
        .querySelector('.extraDrawer-container-jood-benefit [role="alertdialog"]')
        ?.scroll({ top: 0, behavior: 'smooth' });
    }, 250);
  }

  function closePopup() {
    $openPdpJoodBenefitInfoPopup = false;
    open = false;
    $pdpJoodBenefitInfo = null;
    document.documentElement.style.overflow = '';
    document.body.classList.remove('mdc-dialog-scroll-lock');
  }
</script>

<div>
  <Dialog
    bind:open
    fullscreen
    aria-labelledby="fullscreen-title"
    aria-describedby="fullscreen-content"
    on:SMUIDialog:closed={closePopup}
    class="extraDrawer-container-jood-benefit"
  >
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div class="close-btn" on:click={() => closePopup()}>
      <Icon type="font" glyph="close" mobileSize={20} desktopSize={53} />
    </div>
    <Content id="fullscreen-content">
      {#if VIP?.length}
        <section class="jood-benefit-info-content jood-vip">
          <h5 class="jood-benefit-title">{getStr('extra.jood.membership.gold.advantage.text')}</h5>
          <h6 class="jood-benefit-price">
            {@html getStr('jood.prime.per.year.text', [globalCurrencyTag, primeBenefits.vipPrimeProduct.price.value])}
          </h6>
          <div class="jood-benefit-highlights">
            {#each VIP as data}
              <div class="jood-benefit-highlighs-tile">
                <img src={data.imageUrl} alt="jood-highlights" />
                <span class="title">
                  {@html getStr(`extra.jood.vip.checkout.${data.code}.code`)}
                </span>
              </div>
            {/each}
          </div>
          <div class="jood-benefit-description">
            {@html getStr('extra.jood.membership.return.exchange.policy.wallet')}
          </div>
        </section>
      {/if}

      {#if SMART?.length}
        <section class="jood-benefit-info-content jood-basic">
          <h5 class="jood-benefit-title">{getStr('extra.jood.membership.smart.advantage.text')}</h5>
          <h6 class="jood-benefit-price">
            {@html getStr('jood.prime.per.year.text', [globalCurrencyTag, primeBenefits.smartPrimeProduct.price.value])}
          </h6>
          <div class="jood-benefit-highlights">
            {#each SMART as data}
              <div class="jood-benefit-highlighs-tile">
                <img src={data.imageUrl} alt="jood-highlights" />
                <span class="title">
                  {@html getStr(`extra.jood.smart.checkout.${data.code}.code`)}
                </span>
              </div>
            {/each}
          </div>
          <div class="jood-benefit-description">
            {@html getStr('extra.jood.membership.return.smart.exchange.policy.wallet')}
          </div>
        </section>
      {/if}

      {#if BASIC?.length}
        <section class="jood-benefit-info-content jood-basic">
          <h5 class="jood-benefit-title">{getStr('extra.jood.membership.blue.advantage.text')}</h5>
          <h6 class="jood-benefit-price">
            {@html getStr('jood.prime.per.year.text', [globalCurrencyTag, primeBenefits.basicPrimeProduct.price.value])}
          </h6>
          <div class="jood-benefit-highlights">
            {#each BASIC as data}
              <div class="jood-benefit-highlighs-tile">
                <img src={data.imageUrl} alt="jood-highlights" />
                <span class="title">
                  {@html getStr(`extra.jood.basic.checkout.${data.code}.code`)}
                </span>
              </div>
            {/each}
          </div>
          <div class="jood-benefit-description">
            {@html getStr('extra.jood.membership.return.basic.exchange.policy.wallet')}
          </div>
        </section>
      {/if}
      <div class="jood-benefit-info-content-btn">
        <ExtraButton
          color="secondary"
          size="medium"
          variant="solid"
          on:click={() => (window.location.href = `${encodedContextPath}/jood/benefits/`)}
        >
          {getStr('extra.jood.subcription.link.pdp')}
        </ExtraButton>
      </div>
    </Content>
  </Dialog>
</div>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  :global {
    html:has(.mdc-dialog--open) {
      overflow: hidden !important;
    }

    .extraDrawer-container-jood-benefit.mdc-dialog.mdc-dialog--fullscreen {
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1000;
      padding: 40px 20px;

      .mdc-dialog__container {
        justify-content: center;
        align-items: flex-start;
        z-index: 10000;
        height: 100dvh;
        .mdc-dialog__content {
          // max-height: calc(100% - 145px);
          overflow-y: auto;
          scrollbar-width: none; /* Also needed to disable scrollbar Firefox */
          padding: 0;
          &::-webkit-scrollbar {
            display: none;
          }
        }
        .mdc-dialog__actions {
          background-color: $primary-white;
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
        }

        .mdc-dialog__surface {
          width: 612px;
          height: 90vh;
          margin-top: 13%;
          border-radius: 11px;
          background: linear-gradient(180deg, $jood-gold-light 25.88%, $jood-smart-light 40%, $jood-blue-light 95.68%);
          background-attachment: local;
          @include responsive {
            width: 345px;
            margin-top: 15%;
            max-height: max-content;
          }
          .close-btn {
            position: fixed;
            top: 10px;
            right: 28%;
            z-index: 10001;
            color: $primary-white;
            @include responsive {
              top: 20px;
              right: 7%;
            }
          }
        }
      }
      .jood-benefit-info-content {
        &.jood-vip {
          .jood-benefit-highlighs-tile {
            .title {
              strong,
              span {
                color: $jood-wallet-gold-01;
                font-weight: 700;
                font-size: 18px;
                line-height: 20px;
                @include responsive {
                  font-size: 14px;
                  line-height: 16px;
                }
              }
            }
          }
          .jood-benefit-description {
            strong,
            span {
              color: $jood-wallet-gold-01;
              font-weight: 700;
              font-size: 18px;
              line-height: 20px;
              @include responsive {
                font-size: 14px;
                line-height: 16px;
              }
            }
          }
        }
        &.jood-basic {
          .jood-benefit-highlighs-tile {
            .title {
              strong,
              span {
                color: $x-wallet-background;
                font-weight: 700;
                font-size: 18px;
                line-height: 20px;
                @include responsive {
                  font-size: 12px;
                  line-height: 16px;
                }
              }
            }
          }
          .jood-benefit-description {
            strong,
            span {
              color: $x-wallet-background;
              font-weight: 700;
              font-size: 18px;
              line-height: 20px;
              @include responsive {
                font-size: 12px;
                line-height: 16px;
              }
            }
          }
        }
      }

      .jood-benefit-info-content-btn {
        margin: 0px 20px 50px;
        display: flex;
        justify-content: center;
        @include responsive {
          margin: 0px 20px 30px;
        }
        .extra-btn {
          width: 300px;
          border-top: 1px solid $color-grey-border;
          padding-top: 30px;
          min-height: 48px;
          @include responsive {
            width: 100%;
            padding-top: 20px;
          }
          button {
            font-size: 16px;
          }
        }
      }
    }
  }
  .jood-benefit-info-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    gap: 12px;

    @include responsive {
      gap: 6px;
    }
    &.jood-vip {
      color: $jood-wallet-gold-01;
      margin: 50px 40px 30px;
      padding-bottom: 30px;
      border-bottom: 1px solid $color-grey-border;

      @include responsive {
        margin: 20px 25px;
        padding-bottom: 20px;
      }
    }
    &.jood-basic {
      color: $x-wallet-background;
      margin: 30px 40px;
      @include responsive {
        margin: 20px 25px;
      }
    }
    .jood-benefit-title {
      font-weight: 500;
      font-size: 40px;
      line-height: 42px;
      @include responsive {
        font-size: 22px;
        line-height: 24px;
      }
    }
    .jood-benefit-price {
      font-weight: 400;
      font-size: 28px;
      line-height: 30px;
      @include responsive {
        font-size: 18px;
        line-height: 20px;
      }
    }
    .jood-benefit-highlights {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
      gap: 16px;
      margin: 16px 0px;
      @include responsive {
        gap: 8px;
        margin: 8px 0px;
      }
      .jood-benefit-highlighs-tile {
        display: flex;
        flex-direction: column;
        text-align: center;
        align-items: center;
        justify-content: center;
        gap: 8px;
        border-radius: 12px;
        background-color: $primary-white;
        border: 1px solid $jood-gold-medium-01;
        padding: 16px;
        width: 143px;
        height: 184px;
        @include responsive {
          gap: 4px;
          width: 93px;
          height: 120px;
          padding: 4px;
        }
        img {
          width: 65px;
          height: auto;
          @include responsive {
            width: 42px;
          }
        }
        .title {
          font-size: 16px;
          line-height: 20px;
          font-weight: 500;
          letter-spacing: 0;
          color: $color-dove-gray;
          @include responsive {
            font-size: 12px;
            line-height: 14px;
          }
        }
      }
    }
    .jood-benefit-description {
      font-size: 18px;
      line-height: 22px;
      font-weight: 400;
      letter-spacing: 0;
      padding: 0px 15px;
      @include responsive {
        font-size: 14px;
        line-height: 20px;
        padding: 0px;
      }
    }
  }
</style>
